
import { useMemo } from 'react';
import { RegionsData } from '../types';
import { getEnergyDevices, getGasDevices, getWaterDevices } from '../sampleData';

/**
 * Hook for managing region data
 */
export const useRegionData = (regionNames: string[]) => {
  // Create structured regions object
  const regions: RegionsData = useMemo(() => ({
    energy: regionNames,
    gas: regionNames,
    water: regionNames
  }), [regionNames]);
  
  // Device counts by region
  const deviceCounts = useMemo(() => {
    // Initialize counts object
    const counts: Record<string, Record<string, number>> = {
      "Total": { "Energy": 0, "Gas": 0, "Water": 0 }
    };
    
    // Initialize region counts
    regionNames.forEach(region => {
      counts[region] = { "Energy": 0, "Gas": 0, "Water": 0 };
    });
    
    // Count all devices across all departments
    const allDevicesAcrossDepartments = [
      ...getEnergyDevices(),
      ...getGasDevices(),
      ...getWaterDevices()
    ];
    
    // Count devices by region and type
    allDevicesAcrossDepartments.forEach(device => {
      const region = device.department || "Total";
      
      // Map department to display type
      const displayType = device.department || "Unknown";
      
      // Increment region count
      if (counts[region]) {
        counts[region][displayType] = (counts[region][displayType] || 0) + 1;
      }
      
      // Increment total count
      counts["Total"][displayType] = (counts["Total"][displayType] || 0) + 1;
    });
    
    return counts;
  }, [regionNames]);

  return {
    regions,
    deviceCounts
  };
};
